// Module
var code = "<template> <template if.bind=\"invalid === true\"> <validation-message accent=\"negative\" class=\"--single\"> <template replaceable part=\"invalid\">Udfyld venligst alle felter.</template> </validation-message> </template> </template> ";
// Exports
module.exports = code;